import React from 'react';

export type LoadableOwnProps = {
  loading: boolean;
  loader: React.ReactNode;
};

export type LoadableProps = React.PropsWithChildren<LoadableOwnProps>;

/** It render fallback or children given props.loading */
export const Loadable = (props: LoadableProps) => (
  <>{props.loading ? props.loader : props.children}</>
);
